"use strict";
/* eslint-disable @typescript-eslint/no-use-before-define */
'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsProvider = exports.useAnalyticsContext = exports.AnalyticsContext = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var analytics_next_1 = require("@segment/analytics-next");
var navigation_1 = require("next/navigation");
var script_1 = __importDefault(require("next/script"));
var next_plausible_1 = __importDefault(require("next-plausible"));
var react_1 = require("react");
var lib_1 = require("./lib");
var plugins_1 = require("./plugins");
var types_1 = require("./types");
var ONETRUST_INTEGRATION_EVENT = 'OnetrustConsentModalCallback';
exports.AnalyticsContext = (0, react_1.createContext)(undefined);
function useAnalyticsContext() {
    var analyticsContext = (0, react_1.useContext)(exports.AnalyticsContext);
    if (!analyticsContext) {
        throw new Error('No `AnalyticsProvider` found when calling `useAnalyticsContext`');
    }
    return analyticsContext;
}
exports.useAnalyticsContext = useAnalyticsContext;
function PlausibleProviderMaybe(_a) {
    var isEnabled = _a.isEnabled, newsroom = _a.newsroom, plausibleDomain = _a.plausibleDomain, children = _a.children;
    if (!isEnabled ||
        !newsroom ||
        !newsroom.is_plausible_enabled ||
        newsroom.tracking_policy === types_1.TrackingPolicy.DISABLED) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
    }
    return ((0, jsx_runtime_1.jsxs)(next_plausible_1.default, { domain: plausibleDomain !== null && plausibleDomain !== void 0 ? plausibleDomain : newsroom.plausible_site_id, scriptProps: {
            src: 'https://atlas.prezly.com/js/script.outbound-links.js',
            // This is a documented parameter, but it's not reflected in the types
            // See https://github.com/4lejandrito/next-plausible/blob/master/test/page/pages/scriptProps.js
            // @ts-expect-error
            // eslint-disable-next-line @typescript-eslint/naming-convention
            'data-api': 'https://atlas.prezly.com/api/event',
        }, children: [process.env.NODE_ENV === 'test' && (0, jsx_runtime_1.jsx)("div", { "data-testid": "plausible-debug-enabled" }), children] }));
}
function AnalyticsProvider(_a) {
    var _b, _c, _d, _e, _f, _g;
    var cdnUrl = _a.cdnUrl, children = _a.children, _h = _a.cookie, cookie = _h === void 0 ? {} : _h, gallery = _a.gallery, ignoreConsent = _a.ignoreConsent, integrations = _a.integrations, _j = _a.isEnabled, isEnabled = _j === void 0 ? true : _j, isPlausibleEnabled = _a.isPlausibleEnabled, newsroom = _a.newsroom, plausibleDomain = _a.plausibleDomain, plugins = _a.plugins, customSegmentWriteKey = _a.segmentWriteKey, story = _a.story, user = _a.user;
    var _k = newsroom || {}, _l = _k.tracking_policy, trackingPolicy = _l === void 0 ? types_1.TrackingPolicy.DEFAULT : _l, _m = _k.segment_analytics_id, segmentWriteKey = _m === void 0 ? customSegmentWriteKey : _m, uuid = _k.uuid;
    var isOnetrustIntegrationEnabled = (_b = newsroom === null || newsroom === void 0 ? void 0 : newsroom.onetrust_cookie_consent.is_enabled) !== null && _b !== void 0 ? _b : false;
    var onetrustCookieCategory = (_d = (_c = newsroom === null || newsroom === void 0 ? void 0 : newsroom.onetrust_cookie_consent) === null || _c === void 0 ? void 0 : _c.category) !== null && _d !== void 0 ? _d : '';
    var onetrustIntegrationScript = (_f = (_e = newsroom === null || newsroom === void 0 ? void 0 : newsroom.onetrust_cookie_consent) === null || _e === void 0 ? void 0 : _e.script) !== null && _f !== void 0 ? _f : '';
    var _o = __read((0, react_1.useState)(function () {
        if (ignoreConsent) {
            return true;
        }
        if (isOnetrustIntegrationEnabled) {
            return (0, lib_1.getOnetrustCookieConsentStatus)(onetrustCookieCategory);
        }
        return (0, lib_1.getConsentCookie)();
    }), 2), consent = _o[0], setConsent = _o[1];
    var _p = __read((0, react_1.useState)(undefined), 2), analytics = _p[0], setAnalytics = _p[1];
    (0, react_1.useEffect)(function () {
        function loadAnalytics(writeKey) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, response, error_1;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, analytics_next_1.AnalyticsBrowser.load(__assign(__assign({ writeKey: writeKey, 
                                    // eslint-disable-next-line @typescript-eslint/naming-convention
                                    cdnURL: cdnUrl }, (!writeKey && {
                                    cdnSettings: {
                                        integrations: {},
                                    },
                                })), { plugins: __spreadArray(__spreadArray([], __read((uuid
                                        ? [(0, plugins_1.sendEventToPrezlyPlugin)(uuid), (0, plugins_1.normalizePrezlyMetaPlugin)()]
                                        : [])), false), __read((plugins || [])), false) }), __assign({ 
                                    // By default, the analytics.js library plants its cookies on the top-level domain.
                                    // We need to completely isolate tracking between any Prezly newsroom hosted on a .prezly.com subdomain.
                                    cookie: __assign({ domain: document.location.host }, cookie), integrations: integrations, user: user }, (!writeKey && {
                                    // eslint-disable-next-line @typescript-eslint/naming-convention
                                    integrations: { 'Segment.io': false },
                                })))];
                        case 1:
                            _a = __read.apply(void 0, [_b.sent(), 1]), response = _a[0];
                            setAnalytics(response);
                            return [3 /*break*/, 3];
                        case 2:
                            error_1 = _b.sent();
                            // eslint-disable-next-line no-console
                            console.error('Error while loading Analytics', error_1);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        if (isEnabled && trackingPolicy !== types_1.TrackingPolicy.DISABLED) {
            if (!segmentWriteKey && !uuid) {
                // eslint-disable-next-line no-console
                console.warn('Warning: You have not provided neither `newsroom`, nor `segmentWriteKey`. The library will not send any events.');
            }
            loadAnalytics(segmentWriteKey || '');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cdnUrl,
        isEnabled,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(cookie),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(integrations),
        plugins,
        segmentWriteKey,
        trackingPolicy,
        user,
        uuid,
    ]);
    (0, react_1.useEffect)(function () {
        if (!ignoreConsent && typeof consent === 'boolean' && !isOnetrustIntegrationEnabled) {
            (0, lib_1.setConsentCookie)(consent);
        }
    }, [consent, ignoreConsent, isOnetrustIntegrationEnabled]);
    (0, react_1.useEffect)(function () {
        if (!isOnetrustIntegrationEnabled || !onetrustCookieCategory) {
            // Only execute the effect if the OneTrust integration is enabled.
            return noop;
        }
        function handleEvent() {
            setConsent((0, lib_1.getOnetrustCookieConsentStatus)(onetrustCookieCategory));
        }
        document.body.addEventListener(ONETRUST_INTEGRATION_EVENT, handleEvent);
        return function () {
            document.body.removeEventListener(ONETRUST_INTEGRATION_EVENT, handleEvent);
        };
    }, [isOnetrustIntegrationEnabled, onetrustCookieCategory]);
    return ((0, jsx_runtime_1.jsxs)(exports.AnalyticsContext.Provider, { value: {
            analytics: analytics,
            consent: consent,
            gallery: gallery,
            isEnabled: isEnabled,
            isTrackingCookieAllowed: (0, lib_1.isTrackingCookieAllowed)(consent, newsroom),
            newsroom: newsroom,
            story: story,
            setConsent: setConsent,
            trackingPolicy: trackingPolicy,
        }, children: [isOnetrustIntegrationEnabled && onetrustIntegrationScript && ((0, jsx_runtime_1.jsx)(OnetrustCookieIntegration, { script: onetrustIntegrationScript })), (0, jsx_runtime_1.jsx)(GoogleAnalyticsIntegration, { analyticsId: (_g = newsroom === null || newsroom === void 0 ? void 0 : newsroom.google_analytics_id) !== null && _g !== void 0 ? _g : null }), (0, jsx_runtime_1.jsx)(PlausibleProviderMaybe, { isEnabled: isEnabled || isPlausibleEnabled, newsroom: newsroom, plausibleDomain: plausibleDomain, children: children })] }));
}
exports.AnalyticsProvider = AnalyticsProvider;
function OnetrustCookieIntegration(props) {
    var path = (0, navigation_1.usePathname)();
    /*
     * @see https://my.onetrust.com/s/article/UUID-69162cb7-c4a2-ac70-39a1-ca69c9340046?language=en_US#UUID-69162cb7-c4a2-ac70-39a1-ca69c9340046_section-idm46212287146848
     */
    (0, react_1.useEffect)(function () {
        var _a;
        (_a = document.getElementById('onetrust-consent-sdk')) === null || _a === void 0 ? void 0 : _a.remove();
        if (window.OneTrust) {
            window.OneTrust.Init();
            setTimeout(function () {
                var _a;
                (_a = window.OneTrust) === null || _a === void 0 ? void 0 : _a.LoadBanner();
            }, 1000);
        }
    }, [path]);
    return ((0, jsx_runtime_1.jsx)("div", { id: "onetrust-cookie-consent-integration", dangerouslySetInnerHTML: {
            __html: "\n                    ".concat(props.script, "\n                    <script>\n                    window.OptanonWrapper = (function () {\n                      const prev = window.OptanonWrapper || function() {};\n                      return function() {\n                        prev();\n                        document.body.dispatchEvent(new Event(\"").concat(ONETRUST_INTEGRATION_EVENT, "\")); // allow listening to the OptanonWrapper callback from anywhere.\n                      };\n                    })();\n                    </script>"),
        } }));
}
function GoogleAnalyticsIntegration(props) {
    var _a;
    if ((_a = props.analyticsId) === null || _a === void 0 ? void 0 : _a.startsWith('GTM-')) {
        return (0, jsx_runtime_1.jsx)(GoogleTagManager, { analyticsId: props.analyticsId });
    }
    if (props.analyticsId) {
        return (0, jsx_runtime_1.jsx)(GoogleAnalytics, { analyticsId: props.analyticsId });
    }
    return null;
}
function GoogleTagManager(props) {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(script_1.default, { id: "google-tag-manager-bootstrap", dangerouslySetInnerHTML: {
                    __html: "\n                            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n                            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n                            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n                            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n                            })(window,document,'script','dataLayer','".concat(props.analyticsId, "');\n                        "),
                } }), (0, jsx_runtime_1.jsx)("noscript", { children: (0, jsx_runtime_1.jsx)("iframe", { src: "https://www.googletagmanager.com/ns.html?id=".concat(props.analyticsId), height: "0", width: "0", style: { display: 'none', visibility: 'hidden' } }) })] }));
}
function GoogleAnalytics(props) {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(script_1.default, { src: "https://www.googletagmanager.com/gtag/js?id=".concat(props.analyticsId) }), (0, jsx_runtime_1.jsx)(script_1.default, { id: "google-tag-manager-bootstrap", dangerouslySetInnerHTML: {
                    __html: "\n                        window.dataLayer = window.dataLayer || [];\n                        function gtag(){dataLayer.push(arguments);}\n                        gtag('js', new Date());\n                        gtag('config', '".concat(props.analyticsId, "');\n                        "),
                } })] }));
}
function noop() {
    // nothing
}
//# sourceMappingURL=AnalyticsProvider.js.map